export default {
    data() {
      return {
        paginaAtual: 1,
        totalItens: 0,
        itemsPerPage: 10,
        defaultItemsPerPage: 10,
        defaultPaginaAtual: 1,
      };
    },
    methods: {
      atualizarItemsPerPage(itemsPerPage) {
        this.itemsPerPage = itemsPerPage;
        this.paginaAtual = this.defaultPaginaAtual;
        this.buscarItens();
      },
      avancarItemsPerPage(pagina) {
        this.paginaAtual = pagina;
        this.buscarItens();
      },
      buscarItens() {
        // Método vazio, deve ser sobrescrito no componente que usa o mixin
      },
      resetPagination() {
        this.paginaAtual = this.defaultPaginaAtual;
        this.itemsPerPage = this.defaultItemsPerPage;
      },
    },
};